// extracted by mini-css-extract-plugin
export var section = "hero-module--section--3oerX";
export var inner = "hero-module--inner--1wT8P";
export var picWrap = "hero-module--picWrap--39wd3";
export var title = "hero-module--title--nZ6Rm";